import { render, staticRenderFns } from "./ViewCancelCertModal.vue?vue&type=template&id=059a1960"
import script from "./ViewCancelCertModal.vue?vue&type=script&lang=js"
export * from "./ViewCancelCertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports